import React, { Fragment } from 'react';
import { Container, Row, Col } from 'reactstrap';

export const ContentWrapper = props =>
    <div className="content-wrapper">
        {props.children}
    </div>;

export const ContentAbout0 = props =>
    <Fragment>
        <p>
            Sydney oldest and biggest Spearfishing Club
        </p>
        <p>
            <i>
                The Sans Souci Dolphins were established in 1953, and sixty plus years on we are still having a great time, as we grow as a club every day.
                We currently have a membership of over 60 divers, making us the largest spearfishing club in NSW. We strive to deliver what our club members expect from a well established and run club.
            </i>    
        </p>
    </Fragment>;

export const ContentAbout1 = props =>
    <Fragment>
        <p>
            In order to ensure our members get what they need from our club, we maintain a balance of social and competition events throughout the year. We have social outings to restaurants, social dives both locally and abroad, and a variety of competition events. For example, at last year’s Eden Three Way State Titles in July, we booked three houses for our members, and over thirty dolphins attended the event.
        </p>
    </Fragment>;

export const ContentAbout2 = props =>
    <Fragment>
        <p>
            Our club meetings are also a great social night for us all. We have a BBQ at every meeting as well as information/learning nights such as presentations on “Finding Jewfish” by Australian Spearfishing Champion Paul Roso, “Gear maintenance” by Luke Downie of Frogdive Guildford, “Correct Breathing Technique” by Simon Trippe of Australian Spearfishing Academy, plus much more to come over the year. <span className="highlight"></span>
        </p>
    </Fragment>;


export const ContentWhoAmI5 = props =>
    <Fragment>
            <Col>
                The following list outlines areas of project management that Michael has had continued involvement with:
                <Container>
                    <Row>
                        <Col lg={{ size: 5, offset: 1 }}>
                            <ul>
                                <li>AS 4902 - 2000 General Conditions of Contract for Design and Construct</li>
                                <li>AS 4000 - 1997 General Conditions of Contract</li>
                                <li>Early Contractor Involvement(ECI)</li>
                                <li>Tender preparation, invitation, negotiation, recommendation, and appointment</li>
                                <li>Project Control Group(PCG) chair, agenda, and minuting</li>
                                </ul>
                        </Col>
                        <Col lg="5">
                            <ul>
                                <li>Coordination of FFE</li>
                                <li>Project financial reporting, budgeting, and negotiating</li>
                                <li>Local government consent authorities</li>
                                <li>Joint Regional Planning Panels</li>
                                <li>Land Registry Services</li>
                                <li>Utility providers</li>
                                <li>Mine Subsidence Advisory Board</li>
                            </ul>
                        </Col>
                    </Row>
                </Container>
            </Col>
    </Fragment>;



export const ContentWorkMap1 = props =>
    <Fragment>
        <p className="block-header-title-text">
            Birdsmouth<span className="block-header-title-text-highlight">pm</span> services the Sydney metropolitan and regional areas of NSW with the same <span className="block-header-title-text-highlight">focus</span> -  <span className="block-header-title-text-highlight">precision</span> - <span className="block-header-title-text-highlight">delivery</span> toward each project. 
        </p>
    </Fragment>;


export const ContentWorkMap2 = props =>
    <Fragment>
        <p className="block-header-title-text">
            Birdsmouth<span className="block-header-title-text-highlight">pm</span> values the importance of every project development and immerses itself in each project, irrespective of size, scale or volume of work required.
        </p>
    </Fragment>;


export const ContentWorkMap3 = props =>
    <Fragment>
        <p className="block-header-title-text">
           Whether it be project feasibility studies, written advices, refurbishment works, or new build works, Birdsmouth<span className="block-header-title-text-highlight">pm</span> is focused and ready to deliver for its valued clients.
        </p>
    </Fragment>;


export const ContentWorkMap4 = props =>
    <Fragment>
        <p className="block-header-title-text">
            Birdsmouth<span className="block-header-title-text-highlight">pm</span> project values range between $1.0m and $40.0m 
        </p>
    </Fragment>;


export const ContentWorkMap5 = props =>
    <Fragment>
        <p className="block-header-title-text">
            An interior angle of notch cut across the end of a rafter providing a solid support base in transferring roof loads. The birdsmouth provides strength, integrity and support for the wall system, the value on which Birdsmouth<span className="block-header-title-text-highlight">pm</span> is founded.
        </p>
    </Fragment>;






